import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { Button, Loading } from "@nextui-org/react";
import React, { useCallback } from "react";
import { useLocation } from "react-router-dom";
import { NEW, useResumeDataContext, useSessionContext } from "../context";
import styles from "./app-toolbar.module.less";
import { Icon } from "./fa-icon";
import { UserTile } from "./user-tile";

var Wrapper = function Wrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.appToolbar
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.backdrop
  }), /*#__PURE__*/React.createElement(UserTile, null), children), /*#__PURE__*/React.createElement("div", {
    style: {
      height: "64px"
    }
  }));
}; // TODO location awareness


export var AppToolbar = function AppToolbar() {
  var _useResumeDataContext = useResumeDataContext(),
      deleteResume = _useResumeDataContext.deleteResume,
      discardDraftResume = _useResumeDataContext.discardDraftResume,
      hasDraft = _useResumeDataContext.hasDraft,
      isLoaded = _useResumeDataContext.isLoaded,
      isNewResume = _useResumeDataContext.isNewResume,
      isSaving = _useResumeDataContext.isSaving,
      newResume = _useResumeDataContext.newResume,
      resumeId = _useResumeDataContext.resumeId,
      resumeEntry = _useResumeDataContext.resumeEntry,
      saveResume = _useResumeDataContext.saveResume,
      saveResumeAs = _useResumeDataContext.saveResumeAs;

  var sessionUser = useSessionContext();
  var loc = useLocation();
  var isLoggedIn = !!sessionUser;
  var hasResume = !!resumeId && resumeId !== NEW;
  var isInteractiveResumeEditor = /\/interactive/.test(loc.pathname);
  var doNew = useCallback(function () {
    if (hasDraft) {
      if (!confirm("There are unsaved changes. Are you sure you want to discard them?")) return;
    }

    newResume();
  }, [hasDraft, newResume]);
  var doSaveAs = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var newName;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // temporary
            newName = prompt("Enter a name for this resume", resumeEntry === null || resumeEntry === void 0 ? void 0 : resumeEntry.displayName);

            if (newName) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return");

          case 3:
            _context.next = 5;
            return saveResumeAs(newName);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [resumeEntry === null || resumeEntry === void 0 ? void 0 : resumeEntry.displayName, saveResumeAs]);
  var doDelete = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (resumeId) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return");

          case 2:
            if (confirm("Are you sure you want to delete this resume?")) {
              _context2.next = 4;
              break;
            }

            return _context2.abrupt("return");

          case 4:
            _context2.next = 6;
            return deleteResume(resumeId);

          case 6:
            return _context2.abrupt("return", _context2.sent);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [deleteResume, resumeId]);

  if (!isLoggedIn) {
    return /*#__PURE__*/React.createElement(Wrapper, null);
  }

  if (!isInteractiveResumeEditor) {
    return /*#__PURE__*/React.createElement(Wrapper, null);
  }

  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Button.Group, {
    disabled: isLoaded && !isSaving ? undefined : isSaving
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: doNew
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "file"
  }), " New"), (hasResume || isNewResume && hasDraft) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    disabled: !hasDraft || isNewResume,
    onClick: saveResume
  }, isSaving ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      marginRight: "5px",
      marginTop: "4px"
    }
  }, /*#__PURE__*/React.createElement(Loading, {
    type: "spinner",
    color: "white",
    size: "sm"
  })) : /*#__PURE__*/React.createElement(Icon, {
    name: "floppy-disk"
  }), " ", "Save"), /*#__PURE__*/React.createElement(Button, {
    onClick: doSaveAs
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "floppy-disk"
  }), " Save as..."), /*#__PURE__*/React.createElement(Button, {
    disabled: !hasDraft,
    onClick: discardDraftResume
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "rotate-left"
  }), " Discard"), /*#__PURE__*/React.createElement(Button, {
    onClick: doDelete,
    disabled: !hasResume
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "trash-can"
  }), " Delete"))));
};